import { npcLogConstant } from 'src/redux/actions/constant';

const initialState = { response: null, isNpcTeamEntries: false, loading: false };

export const getNpcTeamEntriesReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case npcLogConstant.GET_NPC_TEAM_ENTRIES_SUCCESS:
      return { ...state, isNpcTeamEntries: true, response: action.payload?.data, loading: false };
    case npcLogConstant.GET_NPC_TEAM_ENTRIES_FAILURE:
      // THIN-8233: keep `response` null on failure (never the raw axios error) so the review
      // dashboard's `response || []` then .filter/.map cannot crash the page behind the ErrorBoundary.
      return {
        ...state,
        isNpcTeamEntries: false,
        response: null,
        error: action.payload,
        loading: false,
      };
    case npcLogConstant.GET_NPC_TEAM_ENTRIES_LOADER:
      return { ...state, loading: true };
    case npcLogConstant.GET_NPC_TEAM_ENTRIES_RESET:
      return initialState;
    default:
      return state;
  }
};
